import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';
import PropTypes from 'prop-types';

function PrivateRoute ({ children, ...rest }) {
  const { pathsAllowed, path, role, location: { pathname } } = rest;

  let hasPermission = pathsAllowed && pathsAllowed.includes(path);
  let redirectPath = '/';

  if (role === 'signer') {
    const signerPerm = ['/document', 'document/finished'].includes(pathname) || pathname.startsWith('/document/detail');
    hasPermission = hasPermission && signerPerm;
    redirectPath = '/document';
  }

  if (hasPermission) {
    return (
      <Route {...rest}>
        {children}
      </Route>
    );
  } else {
    return <Redirect to={{ pathname: redirectPath }} />;
  }
}

const mapStateToProps = (state) => {
  let pathsAllowed = [];
  if (state.config.visibleTabs) {
    pathsAllowed = state.config.visibleTabs.reduce(
      (urls, { url }) => {
        urls.push(url);
        return urls;
      }, []);

    return {
      pathsAllowed,
      role: state.config.role
    };
  }
};

PrivateRoute.propTypes = {
  rest: PropTypes.object,
  pathsAllowed: PropTypes.array.isRequired,
  role: PropTypes.string.isRequired
};

export default connect(mapStateToProps, null)(PrivateRoute);
